import { getLoginPath } from './utils/loginEntry'
import router from './router'
import NProgress from 'nprogress'
import store from './store'
import { Message } from 'element-ui'
import { getItem } from './utils/cookie'
import { isRelogin } from './utils/request'
import { localeState, toEnglish, translateUi } from './i18n'

// 调整进度条的速度
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

// Hidden administrative modules must also reject saved customer URLs.
function redirectAdminOnlyPage (to, next) {
  if (to.meta.adminOnly && store.getters.roles !== 'ROLE_ADMIN') {
    next({ path: '/home', replace: true })
    return true
  }
  return false
}

// to：当前位置，from：从哪来
router.beforeEach(async (to, from, next) => {
  if ((to.path === '/login' || to.path === '/portal/sign-in') && to.path !== getLoginPath()) {
    next({ path: getLoginPath(), replace: true })
    return
  }
  // 开启页面进度条
  NProgress.start()
  // The public introduction is independent of sessions and never loads account APIs.
  if (to.path === '/welcome' || to.path === '/portal/login') {
    window.document.title = localeState.locale === 'en' ? 'LabelCheap · Shipping workspace' : 'LabelCheap · 末端发货工作台'
    next()
    return
  }
  // 如果本地已经缓存token
  if (getItem('token')) {
    // 修改网站的标题
    const title = to.meta.title || 'LabelCheap'
    window.document.title = localeState.locale === 'en' ? toEnglish(title) : title
    // 如果用户已登录，则不允许进入登录页面
    if (to.path === '/login' || to.path === '/portal/sign-in') {
      // 跳回首页
      next('/home')
    } else {
      // 判断用户信息是否存在，如果不存在则获取用户信息
      if (store.getters.roles.length === 0) {
        // console.log('获取用户信息: ', count)
        isRelogin.show = true
        try {
          await store.dispatch('user/getUserInfo')
          // Await both requests so a failed menu request cannot leave navigation pending.
          const accessRoutes = await store.dispatch('permission/generateRoutes')
          accessRoutes.forEach(route => router.addRoute(route))
          if (!redirectAdminOnlyPage(to, next)) next({ ...to, replace: true })
        } catch (error) {
          try {
            await store.dispatch('user/logout')
          } finally {
            Message.error(translateUi('登录信息或菜单加载失败，请重新登录'))
            next(getLoginPath())
          }
        } finally {
          isRelogin.show = false
        }
      } else {
        if (!redirectAdminOnlyPage(to, next)) next()
      }
    }
  } else {
    // 放行登录页面
    if (to.path === '/login' || to.path === '/portal/sign-in') {
      next()
    } else {
      // 否则在没有登录之前的一切路由都重定向到登录页面
      next(getLoginPath())
    }
  }
})

router.afterEach((to, from) => {
  // 关闭进度条
  NProgress.done()
})

// Failed lazy-loaded resources must finish progress and report a recoverable error.
router.onError(() => {
  NProgress.done()
  Message.error(translateUi('页面加载失败，请刷新页面后重试'))
})
